import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.prueflauf-berechtigung';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPrueflaufBerechtigungEffects {

    PrueflaufBerechtigung$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_PRUEFLAUF_BERECHTIGUNG),
        mergeMap((x: ac.GetPrueflaufBerechtigungAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getPrueflaufBerechtigung(x.prueflaufStatusRequest).pipe(
                map((result: any) => {
                    return new ac.GetPrueflaufBerechtigungErfolgreichAction(result, x.prueflaufStatusRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetPrueflaufBerechtigungFehlerAction(error, x.prueflaufStatusRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.PrueflaufQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.PrueflaufQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.PrueflaufQueryService);
        }
        return this.service;
    }
}
